import { ref, onMounted, onBeforeUnmount, Ref } from 'vue'

export function useUserActivity(timeout?: number) {
    const timeoutEffective = timeout ?? 30000
    const isUserActive: Ref<boolean> = ref(true)
    let activityTimeoutId: number | undefined

    const resetActivity = () => {
        isUserActive.value = true
        if (activityTimeoutId !== undefined) {
            clearTimeout(activityTimeoutId)
        }
        startInactivityTimer()
    }

    const startInactivityTimer = () => {
        activityTimeoutId = window.setTimeout(() => {
            isUserActive.value = false
        }, timeoutEffective)
    }

    const handleActivity = () => {
        resetActivity()
    }

    onMounted(() => {
        window.addEventListener('mousemove', handleActivity)
        window.addEventListener('keydown', handleActivity)
        window.addEventListener('mousedown', handleActivity)
        window.addEventListener('touchstart', handleActivity)
        startInactivityTimer()
    })

    onBeforeUnmount(() => {
        window.removeEventListener('mousemove', handleActivity)
        window.removeEventListener('keydown', handleActivity)
        window.removeEventListener('mousedown', handleActivity)
        window.removeEventListener('touchstart', handleActivity)
        if (activityTimeoutId !== undefined) {
            clearTimeout(activityTimeoutId)
        }
    })

    return {
        isUserActive
    }
}